import { Section } from 'components/grid'
import React from 'react'
import { formatSectionId } from 'components/core-adoption/functions/formatSectionId'
import { graphql, useStaticQuery } from 'gatsby'
import { IGatsbyImageData } from 'gatsby-plugin-image'
import Accelerator from 'components/intervention/Accelerator'

export default function AcceleratorElementary({ ...props }) {
	const data = useStaticQuery<AcceleratorQuery>(query)

	const { wideReadingElementary, toolkitsElementary } = data

	return (
		<>
			<Section id={formatSectionId(props)} className="scroll-mt-14">
				<Accelerator showFrameworks showLevel={false} level="elementary" wideReading={wideReadingElementary} toolkits={toolkitsElementary} />
			</Section>
		</>
	)
}

export interface AcceleratorBasketQueryEdge {
	edges: { node: { title: string; gatsbyImageData: IGatsbyImageData } }[]
}

export interface AcceleratorToolkitQueryEdge {
	edges: { node: { name: string; images: { gatsbyImageData: IGatsbyImageData }[] } }[]
}

interface AcceleratorQuery {
	wideReadingElementary: AcceleratorBasketQueryEdge
	toolkitsElementary: AcceleratorToolkitQueryEdge
}

const query = graphql`
	query {
		wideReadingElementary: allContentfulAsset(
			filter: {
				title: {
					in: [
						"Wide Reading | 1G Basket 1"
						"Wide Reading | 2G Basket 1"
						"Wide Reading | 1B Basket 1"
						"Wide Reading | 2B Basket 1"
						"Wide Reading | 1R Basket 1"
						"Wide Reading | 2R Basket 1"
						"Wide Reading | Wt Basket 1"
						"Wide Reading | Bk Basket 1"
					]
				}
			}
		) {
			edges {
				node {
					title
					gatsbyImageData
				}
			}
		}
		toolkitsElementary: allContentfulProduct(
			filter: {
				name: {
					in: [
						"IRLA Foundational Skills Toolkit 1G"
						"IRLA Foundational Skills Toolkit 2G"
						"IRLA Foundational Skills Toolkit 1B"
						"IRLA Foundational Skills Toolkit 2B"
						"IRLA Foundational Skills Toolkit 1R"
						"IRLA Foundational Skills Toolkit 2R"
						"IRLA Foundational Skills Toolkit 2R"
						"IRLA Toolkit Wt"
						"IRLA Toolkit Bk"
					]
				}
			}
		) {
			edges {
				node {
					name
					images {
						gatsbyImageData
					}
				}
			}
		}
	}
`
